const imports = {
  mappingFields: 'מיפוי שדות',
  fieldsInDB: 'שדות בבסיס הנתונים',
  csvFields: 'שדה CSV',
  selectTheField: 'בחר את השדה',
  csvFile: 'קובץ CSV',
  typeOfImport: 'סוג ייבוא',
  selectTypeOfReports: 'בחר סוג דוחות',
  default: 'ערך ברירת מחדל',
  uploadedSuccessfuly: 'הועלה בהצלחה!',
  downloadExample: 'הורד דוגמה',
  noCollection: 'אין אוסף עם שם זה',
  uploadMessage: 'בקשה - {{num}} פריטים\nזה עשוי לקחת עד שנייה לכל פריט.',
};

export default imports;
